import { Component, ElementRef, HostListener, Input, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { FileShowingComponent } from '../file-showing-component'
import { Content } from '@monorepo/golab-generated'

const headerBarHeight = 64
const topWhiteSpace = 44
const bottomWhiteSpace = 44
const heightOverhead = headerBarHeight + topWhiteSpace + bottomWhiteSpace

@Component({
  selector: 'app-pdf-content',
  templateUrl: './pdf-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pdf-content.component.scss'],
})
export class PdfContentComponent extends FileShowingComponent {
  constructor() {
    const sanitizer = inject(DomSanitizer);

    super(sanitizer)
  }

  @Input() set content(content: Content | undefined) {
    if (content) {
      this.setPdfProperties(content)
    }
  }

  private _pdfViewer: ElementRef<HTMLObjectElement> | undefined

  @ViewChild('pdfViewer') set pdfViewer(pdfViewer: ElementRef<HTMLObjectElement>) {
    if (pdfViewer) {
      this._pdfViewer = pdfViewer
      setTimeout(() => {
        this.adjustPdfViewerHeightToAvailableWidth()
      }, 0)
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.adjustPdfViewerHeightToAvailableWidth()
  }

  private setPdfProperties(content: Content): void {
    this.setUrl(content)
  }

  private adjustPdfViewerHeightToAvailableWidth() {
    if (!this._pdfViewer) {
      return
    }
    const windowHeight = window.innerHeight
    const newHeight = windowHeight - heightOverhead
    this._pdfViewer.nativeElement.style.height = `${newHeight}px`
    console.log('newHeight', newHeight)
  }
}
